import { observer } from 'mobx-react';
import React from 'react';

import { Button } from '@mui/material';
import Form from 'components/Form';
import Modal, { IModalProps } from 'components/Modal';
import GrowTransition from 'components/Modal/animations/grow';

import SelectField from '@common/components/Form/SelectField';
import TextField from '@common/components/Form/TextField';

import {
	StyledAppointmentsBookingModalBlock,
	StyledAppointmentsBookingModalForm,
	StyledAppointmentsBookingModalLabel,
} from './styled';

interface BookingFormValues {
	day: string;
	time: string;
	format: string;
	program: string;
	phone: string;
}

interface PropsType extends Omit<IModalProps, 'title' | 'onSubmit'> {
	initialValues: any;
	onSubmit: (data: BookingFormValues) => void;
}

function MeetModal({ initialValues, onSubmit, ...props }: PropsType) {
	return (
		<Modal
			PaperProps={{
				sx: {
					maxWidth: '500px',
				},
			}}
			title="Booking"
			TransitionComponent={GrowTransition}
			transitionDuration={500}
			{...props}
		>
			<Form initialValues={initialValues} onSave={onSubmit} hideActions>
				{({ values }) => (
					<StyledAppointmentsBookingModalForm>
						<TextField name="day" disabled label="Day" />
						<TextField name="time" disabled label="Time" />
						<TextField name="phone" disabled label="Phone" />
						<SelectField
							disabled
							label="Format"
							name="format"
							sx={{
								borderRadius: '10px',
								background: '#FFF',
								overflow: 'hidden',
								boxShadow: '5px 4px 10.8px 0px rgba(166, 203, 245, 0.28)',
								border: 'none',
							}}
							options={[
								{
									label: 'Online',
									value: 'online',
								},
								{
									label: 'Offline',
									value: 'offline',
								},
							]}
						/>
						{values.format === 'online' && (
							<>
								<TextField disabled label="Zoom access code" name="zoom_access_code" />
								<TextField disabled label="Zoom id" name="zoom_id" />
								<StyledAppointmentsBookingModalBlock>
									<StyledAppointmentsBookingModalLabel>
										Zoom link:
									</StyledAppointmentsBookingModalLabel>
									<a href={values.zoom_link} target="_blank" rel="noreferrer">
										{values.zoom_link}
									</a>
								</StyledAppointmentsBookingModalBlock>
							</>
						)}
						{values.comment_teacher && (
							<TextField disabled label="Admin comment" name="comment_teacher" />
						)}
						{values.comment_student && (
							<TextField disabled label="Comment" name="comment_student" />
						)}
						<Button variant="contained" type="submit" color="error">
							Delete
						</Button>
					</StyledAppointmentsBookingModalForm>
				)}
			</Form>
		</Modal>
	);
}

export default observer(MeetModal);
